import { create } from 'zustand'
import * as IssueAPI from '../../../API/IssueApi'
import { devtools } from 'zustand/middleware'
import { immer } from 'zustand/middleware/immer'

const initialState = {
    Loader: false,
    issueInfoData: {},
    DataError: '',
    getIssueHistoryData: [],
    getIssuePeriodicityData: [],
    issueDetailsLoading: false,
    issueDetails: [],
    issueDashboardDetails: [],
    tableBodyData: [],
    IssueDetailsByIdLoading: false,
    issueDetailsById: [],
    // create Risk
    issueInitialCount: null,
    issuePlanningCount: null,
    issuePendingCount: null,
    issueCloseCount: null,
    createIssueDataLoading: false
}

const IssueStore = create(devtools(immer((set, get) => ({
    ...initialState,
    getIssueHistory: async (riskId, orgId) => {
        set({ issueDetailsLoading: true })
        try {
            const response = await IssueAPI.getIssueHistory(riskId, orgId)
            set({ issueDetailsLoading: false, getIssueHistoryData: response.data })
        } catch (error) {
            set({ issueDetailsLoading: false, getIssueHistoryData: [] })
        }
    },
    getIssuePeriodicity: async (riskId, loginId, orgId) => {
        set({ issueDetailsLoading: true })
        try {
            const response = await IssueAPI.getIssuePeriodicity(riskId, loginId, orgId)
            set({ issueDetailsLoading: false, getIssuePeriodicityData: response.data })
        } catch (error) {
            set({ issueDetailsLoading: false, getIssuePeriodicityData: [] })
        }
    },
    CreateIssue: async (loginId, data) => {
        set({ createissueDataLoading: true })
        try {
            const response = await IssueAPI.createIssue(loginId, data)
            set({ createIssueDataLoading: false })
            return response
        } catch (err) {
            set({ createIssueDataLoading: false })
        }
    },
    getIssueDetailsById: async (riskId, loginId) => {
        set({ IssueDetailsByIdLoading: true })
        try {
            const response = await IssueAPI.getIssueDetailsById(riskId, loginId)
            if (response.data) {
                set({ IssueDetailsByIdLoading: false, issueDetailsById: response.data })
            } else {
                set({ IssueDetailsByIdLoading: false })
            }
        } catch (error) {
            set({ IssueDetailsByIdLoading: false })
        }
    },
    getIssueDetails: async (pageNumber, pageSize, type, stage, loginId) => {
        set({ issueDetailsLoading: true })
        let dataKey = ''
        switch (stage) {
            case 1:
                dataKey = 'issueInitialCount'
                break
            case 2:
                dataKey = 'issuePlanningCount'
                break
            case 3:
                dataKey = 'issuePendingCount'
                break
            case 4:
                dataKey = 'issueCloseCount'
                break
            default:
                dataKey = 'issueInitialCount' // or handle default case accordingly
                break
        }
        try {
            const response = await IssueAPI.getIssueDetails(pageNumber, pageSize, type, stage, loginId)
            set({ issueDetailsLoading: false, issueDetails: response.data, [dataKey]: response.data.length, tableBodyData: response.data })
        } catch (error) {
            set({ issueDetailsLoading: false, issueDetails: [], tableBodyData: [] })
        }
    },
    getIssueDashboard: async (pageNumber, pageSize, loginId) => {
        set({ issueDetailsLoading: true })
        try {
            const response = await IssueAPI.getIssueDashboard(pageNumber, pageSize, loginId)
            set({ issueDetailsLoading: false, issueDashboardDetails: response.data })
        } catch (error) {
            set({ issueDetailsLoading: false, issueDashboardDetails: [] })
        }
    },
    getIssueDetailsCount: async (pageNumber, pageSize, type, stage, loginId) => {
        set({ riskInitialCountLoading: true })
        let dataKey = ''
        switch (stage) {
            case 1:
                dataKey = 'issueInitialCount'
                break
            case 2:
                dataKey = 'issuePlanningCount'
                break
            case 3:
                dataKey = 'issuePendingCount'
                break
            case 4:
                dataKey = 'issueCloseCount'
                break
            default:
                dataKey = 'issueInitialCount' // or handle default case accordingly
                break
        }
        try {
            const response = await IssueAPI.getIssueDetails(pageNumber, pageSize, type, stage, loginId)
            if (response.data) {
                set({ issueInitialCountLoading: false, [dataKey]: response.data.length > 0 ? response.data[0].total : 0 })
            } else {
                set({ issueInitialCountLoading: false })
            }
        } catch (error) {
            set({ issueInitialCountLoading: false })
        }
    }
}

))))

export const useIssueStore = IssueStore
